import axios from 'axios';
import Globals from '../Globals';
import { getLogModel } from '../Functions';
import LoggingService from './LoggingService';

class DealerService {
        constructor() {
        this.axiosInstance = axios.create({
            baseURL: Globals.BFF_PATH.BASE_URL + Globals.BFF_PATH.DEALER_SERVICE.BASE_PATH,
        });
    }

    getDealersList = async (token, userId) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: Globals.ERROR_CODE,
            },
            body: JSON.stringify(''),
        };
        const data = {
            body: JSON.stringify({ UsuarioId: userId }),
        };
        return await this.axiosInstance
            .post(Globals.BFF_PATH.DEALER_SERVICE.GET_REMA_DEALERSHIPS, data, config)
            .then(response => {
                if (response && response.data && response.data.body) {
                    response.data.body = JSON.parse(response.data.body);
                }
                return response.data;
            })
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error?.config?.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
    };

}

const dealerService = new DealerService();
export default dealerService;
